var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"play_warp",class:{orienta: _vm.isOrienta},attrs:{"id":"play_warp"}},[_c('div',{attrs:{"id":"J_prismPlayer"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }